import { qltClient } from '../clients';
import { Repository } from '../core/repository';
import type { QueryParams } from '../core/params';
import type { QltStudent } from '../types';

export const StudentRepository = {
  ...Repository<QltStudent>(qltClient, '/students'),
  getBasicStudentData: (params?: QueryParams) =>
    qltClient.get('/getBasicStudentData', { params }).then((res) => res.data as QltStudent[]),
};

export default StudentRepository;
